<!-- <p>risk-breakdown-graph works!</p> -->
<div class="demo-chart-wrapper">
  <div
    echarts
    id="chart"
    [options]="chartOption"
    [ngStyle]="height ? { height: height } : {}"
    class="demo-chart"
  ></div>
</div>
